import { gql } from "apollo-angular";

export const GET_EESE_REQUIREMENT_QUERY = gql`query configuratorEeseGetRequirement($EeseRequirementInput: EeseRequirementRequestInput) {
  configuratorEeseGetRequirement(EeseRequirementInput: $EeseRequirementInput) {
      Id
      Name
      Variant
      Revision
      Asil
      CyberSecurity
    }
  }
  `
